import React, { useState, useCallback } from "react";
import "../design.css";
import InfoIcon from "../../../shared-components/Info-Icon/InfoIcon";
import { Dropdown } from "primereact/dropdown";
import { ColorPicker } from "primereact/colorpicker";
import "../settings.css";

const SettingsContent = (props) => {
  const { dataContent, onChange } = props;
  const [bgColor, setBgColor] = useState(
    dataContent.surveyheadingBackground["background-color"]
  );
  const [titleColor, setTitleColor] = useState(
    dataContent.surveyheadingForeground["color"]
  );

  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(this, args), delay);
    };
  }

  const debouncedOnChange = useCallback(
    debounce((event) => onChange(event, "surveyheadingBackgroundColor"), 500),
    []
  );

  const onChangeColor = (event) => {
    setBgColor(`#${event.value}`);
    debouncedOnChange(event);
  };

  const debouncedOnTitleChange = useCallback(
    debounce((event) => onChange(event, "surveyheadingForeground"), 500),
    []
  );
  const onTitleChangeColor = (event) => {
    setTitleColor(`#${event.value}`);
    debouncedOnTitleChange(event);
  };
  const dropDownOptions = [
    { label: "Left", value: "left" },
    { label: "Right", value: "right" },
  ];

  const handleInputChange = (event) => {
    const value = event.target.value;
    // Check if the input value is a valid color code
    if (/^#[0-9A-F]{6}$/i.test(value)) {
      onChangeColor(value);
    }
    setBgColor(value);
  };

  const handleTitleChangeColor = (event) => {
    const value = event.target.value;
    // Check if the input value is a valid color code
    if (/^#[0-9A-F]{6}$/i.test(value)) {
      onTitleChangeColor(value);
    }
    setTitleColor(value);
  };
  return (
    <div className="">
      <div className="row align-items-center form-now">
        <div className="col-12 col-md-4 col-lg-4 tab-view">Logo Position</div>
        <div className="col-12 col-md-5 col-lg-4 control-col">
          <select
            className="form-select form-select-md"
            value={dataContent.logoPosition ?? "right"}
            onChange={(e) =>
              onChange(e.target.value, "logoPosition", dataContent)
            }
          >
            {dropDownOptions.map((opt) => (
              <option key={opt.value ?? opt} value={opt.value ?? opt}>
                {opt.label ?? opt}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="row align-items-center  mt-2">
        <div className="col-12 col-md-4 col-lg-4 tab-view">
          Heading Background Colour
        </div>
        <div className="col-12 col-md-5 col-lg-4 control-col d-flex align-items-center gap-2">
          <input
            type="text"
            className="form-control form-control-md"
            value={bgColor}
            onChange={handleInputChange}
          />
          <ColorPicker
            value={bgColor}
            onChange={onChangeColor}
            style={{ width: "40px", height: "40px",marginTop:"4px" }}
          />
        </div>
      </div>

      {/* Survey Heading Title Colour */}
      <div className="row align-items-center">
        <div className="col-12 col-md-4 col-lg-4 tab-view">Heading Title Colour</div>
        <div className="col-12 col-md-5 col-lg-4 control-col d-flex align-items-center gap-2">
          <input
            type="text"
            className="form-control form-control-md"
            value={titleColor}
            onChange={handleTitleChangeColor}
          />
          <ColorPicker
            value={titleColor}
            onChange={onTitleChangeColor}
            style={{ width: "40px", height: "40px" , marginTop:"4px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsContent;
